import React from 'react';

import logo from '../assets/logo.png';

export const Logo = () => {
  return <img src={logo} alt="logo" width="300px" />;
};
